export class CibliError extends Error {
  response: {
    data: {
      message: string;
      code?: string;
    };
  };

  constructor(message: string, code?: string) {
    super(message);
    this.name = 'CibliError';
    this.response = {
      data: {
        message,
        code,
      },
    };
  }
}
